var tuiDialog: HTMLDialogElement;
var tuiMessage: HTMLElement;
var tuiConfirmBtn: HTMLButtonElement;
var tuiCancelBtn: HTMLButtonElement;
var pendingAction: (() => void) | null = null;
var pendingResolve: ((value: boolean) => void) | null = null;
var confirmAccelerator: string = "";

function createDialog() {
    tuiDialog = document.createElement("dialog");
    tuiDialog.className = "tui-modal";
    tuiDialog.innerHTML =
        '<div class="tui-modal-box">' +
            '<p class="tui-modal-message"></p>' +
            '<div class="tui-modal-buttons">' +
                '<button type="button" class="tui-modal-confirm"></button>' +
                '<button type="button" class="tui-modal-cancel">[ <u>C</u>ancel ]</button>' +
            '</div>' +
        '</div>';
    document.body.appendChild(tuiDialog);

    tuiMessage = tuiDialog.querySelector(".tui-modal-message")!;
    tuiConfirmBtn = tuiDialog.querySelector(".tui-modal-confirm")!;
    tuiCancelBtn = tuiDialog.querySelector(".tui-modal-cancel")!;

    tuiConfirmBtn.addEventListener("click", function () {
        var action = pendingAction;
        var resolve = pendingResolve;
        pendingAction = null;
        pendingResolve = null;
        tuiDialog.close();
        if (action) action();
        if (resolve) resolve(true);
    });

    tuiCancelBtn.addEventListener("click", close);

    tuiDialog.addEventListener("click", function (e) {
        if (e.target === tuiDialog) close();
    });

    tuiDialog.addEventListener("cancel", function (e) {
        e.preventDefault();
        close();
    });

    tuiDialog.addEventListener("keydown", function (e) {
        if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
            e.preventDefault();
            var active = document.activeElement === tuiConfirmBtn ? tuiCancelBtn : tuiConfirmBtn;
            active.focus();
        } else if (e.key === "Enter") {
            e.preventDefault();
            (document.activeElement as HTMLElement)?.click();
        } else if (confirmAccelerator && e.key.toLowerCase() === confirmAccelerator) {
            e.preventDefault();
            tuiConfirmBtn.click();
        } else if (e.key.toLowerCase() === "c") {
            e.preventDefault();
            close();
        }
    });
}

function show(message: string, confirmLabel: string, accelerator?: string) {
    tuiMessage.textContent = message;
    var accelChar = accelerator || confirmLabel.charAt(0);
    confirmAccelerator = accelChar.toLowerCase();
    var accelIndex = confirmLabel.toLowerCase().indexOf(confirmAccelerator);
    if (accelIndex >= 0) {
        tuiConfirmBtn.innerHTML = "[ " + confirmLabel.substring(0, accelIndex) + "<u>" + confirmLabel.charAt(accelIndex) + "</u>" + confirmLabel.substring(accelIndex + 1) + " ]";
    } else {
        tuiConfirmBtn.innerHTML = "[ <u>" + confirmLabel.charAt(0) + "</u>" + confirmLabel.substring(1) + " ]";
    }
    tuiDialog.showModal();
    tuiCancelBtn.focus();
}

function close() {
    tuiDialog.close();
    var resolve = pendingResolve;
    pendingAction = null;
    pendingResolve = null;
    if (resolve) resolve(false);
}

document.addEventListener("click", function (e) {
    var el = (e.target as HTMLElement).closest("[data-modal-confirm]") as HTMLElement | null;
    if (!el) return;

    e.preventDefault();
    e.stopPropagation();

    var message = el.getAttribute("data-modal-confirm") || "";
    var confirmLabel = el.getAttribute("data-modal-confirm-label") || "OK";
    var accelerator = el.getAttribute("data-modal-confirm-accelerator") || undefined;
    var form = el.closest("form");

    pendingAction = function () {
        if (form) form.submit();
    };
    pendingResolve = null;

    show(message, confirmLabel, accelerator);
}, true);

interface TuiConfirmOptions {
    message: string;
    confirmLabel?: string;
    accelerator?: string;
}

(window as any).tuiConfirm = function (options: TuiConfirmOptions | string): Promise<boolean> {
    var message = typeof options === "string" ? options : options.message;
    var confirmLabel = typeof options === "string" ? "OK" : (options.confirmLabel || "OK");
    var accelerator = typeof options === "string" ? undefined : options.accelerator;

    return new Promise(function (resolve) {
        pendingAction = null;
        pendingResolve = resolve;
        show(message, confirmLabel, accelerator);
    });
};

document.addEventListener("DOMContentLoaded", createDialog);
